import createDuck from '../lib/MetagnosticDuck'
import { getExpense, getExpenses } from '../lib/APIClient'
import getEmptyExpense from '../lib/emptyExpense.js'

const duck = createDuck(
  "EXPENSES", 
  getExpense, 
  getExpenses, 
  {}, 
  getEmptyExpense, 
  null, 
  { expunge: true }
)

export const createExpense = duck.actions.createDoc
export const receiveExpenses = duck.actions.receiveCollection
export const receiveExpense = duck.actions.receiveDoc
export const removeExpense = duck.actions.removeDoc
export const fetchExpenses = duck.actions.fetchCollection
export const updateExpense = duck.actions.updateDoc

export default duck
